import { NOT_FOUND_STATUS_CODE } from '@constants/api.ts';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROUTES } from '@router/constants.ts';
import type { UserInfoResponse } from '@routes/___shared___/user.api.ts';
import { getUserInfo } from '@routes/___shared___/user.api.ts';
import { getPoints } from '@routes/sidebar/learning/model/learning.slice.ts';
import { extractError } from '@utils/slice.ts';

export interface UserSlice {
    error: Record<string, any> | null;
    userInfo: UserInfoResponse | null;
    score: number;
    isGetFullUserInfoPending: boolean;
}

const initialState: UserSlice = {
    error: null,
    userInfo: null,
    score: 0,
    isGetFullUserInfoPending: false,
};

export const getFullUserInfo = createAsyncThunk<UserInfoResponse, void, { rejectValue: any }>(
    'user/getUserInfo',
    (_, { rejectWithValue }) =>
        getUserInfo()
            .then((res) => {
                return res;
            })
            .catch((err) => {
                return rejectWithValue(err);
            }),
);

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getFullUserInfo.pending, (state) => {
            state.error = null;
            state.isGetFullUserInfoPending = true;
        });
        builder.addCase(getFullUserInfo.fulfilled, (state, action) => {
            state.userInfo = action.payload;
            state.score = action.payload.userState.score;
            state.isGetFullUserInfoPending = false;
        });
        builder.addCase(getFullUserInfo.rejected, (state, action) => {
            state.error = extractError(action);
            state.isGetFullUserInfoPending = false;
            if (action?.payload?.status === NOT_FOUND_STATUS_CODE) {
                window.location.replace(`${window.location.origin}/${ROUTES.DEFAULT.NOT_FOUND}`);
            }
        });
        builder.addCase(getPoints.fulfilled, (state, action) => {
            state.score = action.payload.score;
        });
    },
});

export default userSlice.reducer;
